import React from "react";
import { useNavigate } from "react-router";
import { getString, isLoggedInWithRole, isLoggedInWithoutRole } from "../../utilities";
import { getLangCode, getSearchParamString, language, userRoles } from "../../config";
import { routeCodes } from "../../config/routes";

export default function Trouble({ isGameFree, gameData = null }) {
  const navigate = useNavigate();

  // default paywalled
  let stringPath = "join.8"; // anonymous & free users
  let navPath = routeCodes.SUBSCRIBE; // anonymous
  let options = undefined;

  if (isLoggedInWithoutRole(userRoles.free)) {
    // premium user
    stringPath = "game.trouble";
    navPath = routeCodes.FAQ;

    if (gameData) {
      // only used on the FAQ route
      options = { state: { gameData } };
    }
  } else if (isLoggedInWithRole(userRoles.free)) {
    // free user
    navPath = { pathname: routeCodes.MANAGE, hash: getSearchParamString("subscription") };

    if (isGameFree) {
      stringPath = getLangCode() === language.default ? "upgrade.title.3" : "join.7";
    }
  } else if (isGameFree) {
    // anonymous user
    stringPath = "join.7";
  }

  return (
    <button
      type="button"
      className="button-flat-color round dimensional orange auto trouble"
      onClick={() => {
        navigate(navPath, options);
      }}
    >
      {getString(stringPath)}
    </button>
  );
}
